import { Box, Typography, useTheme } from "@mui/material";
import { ReactNode } from "react";
import { DocumentError } from "src/components/error/error-illustrations/DocumentError";
import { SenecBaseTheme } from "src/newsenec-ui-components";

export interface ChartErrorViewProps {
    /**
     * Error message to be displayed.
     */
    message: string;
    /**
     * Error illustration to be displayed.
     */
    img?: ReactNode;
    /**
     * Error code to be displayed when loading page content. Will not be displayed if no value passed.
     */
    errorCode?: string;
}

export const ChartErrorView = ({ message, img, errorCode }: ChartErrorViewProps) => {
    const theme: SenecBaseTheme = useTheme();

    return (
        <Box display="flex" flexDirection="column" alignItems="center" p={2} width={"fit-content"} m={"auto"}>
            <Box data-testid={"error-img"} width={"fit-content"} m={"auto"}>
                {img !== undefined ? img : <DocumentError />}
            </Box>
            <Box pt={3} maxWidth={"411px"}>
                <Typography variant={"h4"} align={"center"} sx={{ paddingBottom: "8px" }}>
                    {message}
                </Typography>
                {errorCode && (
                    <Typography variant={"subtitle1"} align={"center"} color={theme.palette.neutralGray50.main}>
                        {errorCode}
                    </Typography>
                )}
            </Box>
        </Box>
    );
};
